import { render, staticRenderFns } from "./materialize_form.vue?vue&type=template&id=6dfff7d1&scoped=true&"
import script from "./materialize_form.vue?vue&type=script&lang=js&"
export * from "./materialize_form.vue?vue&type=script&lang=js&"
import style0 from "./materialize_form.vue?vue&type=style&index=0&id=6dfff7d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfff7d1",
  null
  
)

export default component.exports